import routerOptions0 from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/app/router.options.ts";
import routerOptions1 from "/Users/lap15126/Documents/VNG-Corporation/evms-retail-portal/node_modules/.pnpm/nuxt@3.2.2_@types+node@18.14.0_eslint@8.34.0_rollup@2.79.1_sass@1.58.3_typescript@4.9.5/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}